import { useEffect } from "react"
import { Platform } from "react-native"
import { ContactListCacheService } from "src/services/cache/ContactListCacheService"

/**
 * WEB環境でブラウザリロード時にキャッシュをクリアするhook
 *
 * アプリのPull-to-Refresh相当の処理を実現
 * - ブラウザのリロードボタン（F5/Cmd+R）押下時に実行
 * - localStorageの連絡一覧・詳細キャッシュをクリア
 * - 団体ニックネーム、アカウント画像、連絡内容の変更が即座に反映される
 */
export const useWebReloadCacheClear = () => {
  useEffect(() => {
    if (Platform.OS !== "web") return

    // ページリロードかどうかをチェック
    const navEntries = performance.getEntriesByType("navigation")
    if (navEntries.length > 0) {
      const navEntry = navEntries[0] as PerformanceNavigationTiming

      if (navEntry.type === "reload") {
        console.log("[Cache] Browser reload detected - invalidating cache (Pull-to-Refresh equivalent)")

        // Pull-to-Refreshと同じ処理: すべてのキャッシュを無効化
        // localStorage全体をクリア（contact-list-cache関連のみ）
        ContactListCacheService.clearAll()

        console.log("[Cache] All cache cleared successfully")
      }
    }
  }, [])
}
